import React, { Component } from "react";
import validator from "validator";
//icons
import { IoIosCloseCircleOutline } from "react-icons/io";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { RiFacebookFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import loco from "../../images/games/loco.png";
//utils
import { capitalize } from "../../utils/common.utils";
import {
  baseUrls,
  handleTypes,
  socialMediaRegex,
  getPlatformDetails,
  validateSocialMediaUrl,
  generateSocialMediaPlaceholders,
  generateSocialMediaErrorMessages,
} from "../../utils/socialmedia.utils";
//css
import "../../styles/Organization.css";

class AddMoreDetails extends Component {
  constructor(props) {
    super(props);
    // Create a new copy of data for local state
    this.state = {
      socialFieldArr: JSON.parse(JSON.stringify(this.props.data || [])),
    };
  }

  updateDetails = (e, i) => {
    let { socialFieldArr } = this.state;
    socialFieldArr[i].value = e.target.value;

    // Validate URL immediately when user types
    if (socialFieldArr[i].value !== "") {
      socialFieldArr[i].error = validateSocialMediaUrl(
        socialFieldArr[i].value,
        socialFieldArr[i].key
      );
    } else {
      socialFieldArr[i].error = "";
    }

    this.setState({ socialFieldArr });
  };

  handleClose = () => {
    // Create a synthetic event to prevent default behavior
    const e = { preventDefault: () => {} };
    this.props.toggleAddMoreDetails(e);
  };

  validateDetails = () => {
    let errors = 0;
    const filledFields = this.state.socialFieldArr.map(field => {
      let error = "";
      if (field.value !== "") {
        error = validateSocialMediaUrl(field.value, field.key);
      }
      if (error) {
        errors++;
      }
      return { ...field, error };
    });

    this.setState({ socialFieldArr: filledFields });
    if (errors > 0) {
      return false;
    } else {
      return true;
    }
  };

  passDetails = () => {
    if (this.validateDetails()) {
      // Only pass data to parent when Add is clicked
      const validFields = this.state.socialFieldArr.filter(field => !field.error);
      this.props.renderAddedDetails(validFields);
    }
  };

  showFields = (i, value) => {
    const newArray = [...this.state.socialFieldArr]; // Create a copy to avoid direct state mutation
    let temp = { ...newArray[i] }; // Create a copy of the item
    temp.isChecked = value;
    // If hiding the field, clear the value and error
    if (!value) {
      temp.value = "";
      temp.error = "";
    }
    newArray[i] = temp;
    this.setState({ socialFieldArr: newArray });
  };

  render() {
    if (!this.state.socialFieldArr || this.state.socialFieldArr.length === 0) {
      return null;
    }

    return (
      <>
        <form className="p-3">
          <p className="fs-16 fw-600 text-center text-white mb-0">Add Social Media</p>
          <IoIosCloseCircleOutline
            className="close-icon position-absolute"
            style={{ right: "20px", top: "15px" }}
            onClick={this.handleClose}
          />
          <p className="fs-14 text-center fw-500 text-white mb-0 mt-3">
            Please select the social media platform you wish to connect.
          </p>
          <div className="row">
            {this.state.socialFieldArr.map((el, i) => {
              const platformDetails = getPlatformDetails(el.key);
              // Only show placeholder if the field is checked and value is empty
              const placeholder =
                el.isChecked && !el.value ? platformDetails.placeholder || "" : "";
              return el.isChecked ? (
                <div className="mb-2" key={i}>
                  <label htmlFor="facebook" className="fs-14 fw-600 text-white">
                    {capitalize(el.label)}
                  </label>
                  <div className="position-relative">
                    {/* Render React icon based on key, absolutely positioned inside input */}
                    {el.key === "instagram" && (
                      <AiFillInstagram
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "facebook" && (
                      <RiFacebookFill
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "x" && (
                      <FaXTwitter
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "twitch" && (
                      <FaTwitch
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "telegram" && (
                      <FaTelegramPlane
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "youtube" && (
                      <AiFillYoutube
                        className="position-absolute"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "loco" && (
                      <img
                        src={loco}
                        className="position-absolute"
                        alt="loco"
                        style={{
                          left: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: 20,
                          height: 20,
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    <input
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 text-white fs-14 height-45"
                      autoComplete="off"
                      onChange={e => this.updateDetails(e, i)}
                      value={el.value}
                      placeholder={placeholder}
                      style={{ paddingLeft: 40, paddingRight: 40 }}
                    />
                    <AiOutlineMinusCircle
                      className="text-white position-absolute cursor-pointer"
                      style={{ right: 10, top: "50%", transform: "translateY(-50%)" }}
                      onClick={() => {
                        this.showFields(i, false);
                      }}
                    />
                  </div>
                  <p className="error-msg">{el.error}</p>
                </div>
              ) : (
                <div className="col-12 d-flex flex-row mb-2" key={i}>
                  <div
                    className="black-flat-btn d-flex flex-row align-items-center mx-auto height-45 rounded-10 mt-2 w-100 cursor-pointer"
                    onClick={() => {
                      this.showFields(i, true);
                    }}
                  >
                    {/* Render React icon based on key */}
                    {el.key === "instagram" && (
                      <AiFillInstagram
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "facebook" && (
                      <RiFacebookFill
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "x" && (
                      <FaXTwitter
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "twitch" && (
                      <FaTwitch
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "telegram" && (
                      <FaTelegramPlane
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "youtube" && (
                      <AiFillYoutube
                        className="ms-3"
                        style={{
                          width: 20,
                          height: 20,
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "loco" && (
                      <img
                        src={loco}
                        className="ms-3"
                        alt="loco"
                        style={{ width: 20, height: 20, filter: "drop-shadow(0 0 4px #888)" }}
                      />
                    )}
                    <p className="fs-14 fw-500 text-white ms-3 my-auto">{capitalize(el.label)}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className="white-flat-btn d-block fw-bold py-1 px-4 m-auto mt-3 mb-2"
            type="button"
            onClick={this.passDetails}
          >
            Add
          </button>
        </form>
      </>
    );
  }
}

export default AddMoreDetails;
